// import {applyMiddleware, createStore} from 'redux';
import reducer from './reducers';
// The skipLibCheck: true is not work here. So we can only user 'require'.
const {createStore} = require('redux');

export default createStore(reducer);
